import type { RoomDetailsProps } from 'src/features/room/room.types';

export interface CertificateProps {
  roomCode: RoomDetailsProps['code'];
  roomProgress?: number;
  isRetired?: boolean;
}

export enum CertificateType {
  ROOM = 'room',
  PATHWAY = 'pathway',
}

export interface CertificateData {
  code: string;
  type: CertificateType;
}
